import { ArchiveArrowDownIcon } from './ArchiveArrowDownIcon';

/**
 * author: frankgrinaert
 * id 237B205E-C03C-424A-93F9-8C771FE01A38
 * name archive-arrow-down
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-down.svg
 * tags
 */
export const BoxArrowDownIcon = ArchiveArrowDownIcon;
export default BoxArrowDownIcon